import React from 'react';
import RecipeDetailContainer from '../containers/RecipeDetail';

function RecipeDetail() {
  return (
    <div>
      <RecipeDetailContainer />
    </div>
  );
}

export default RecipeDetail;